export default "__VITE_ASSET__BhNgV$fU__"